"use client";

import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

type LineChartDataItem = {
    x: number;
    currentLoan: number;
    refiLoan: number;
};

const BreakEvenLineChart = ({ data }: { data: LineChartDataItem[] }) => {
    return (
        <div className="w-full h-64 2xl:w-[874px] 2xl:h-[400px] 2xl:mx-auto">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
                    <CartesianGrid stroke="#ccc" strokeDasharray="0" vertical={false} />
                    <XAxis dataKey="x" type="number" domain={[0, 1]} tick={{ fontSize: 12 }} />
                    <YAxis
                        tickFormatter={(value) => (value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value)}
                        stroke="#666"
                        tickLine={false}
                        axisLine={false}
                        tick={{ fontSize: 12 }}
                    />
                    <Tooltip
                        formatter={(value: number, name: string) => [
                            `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}`,
                            name === "currentLoan" ? "Current Loan" : "Refinanced Loan",
                        ]}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="currentLoan"
                        name="Current Loan"
                        stroke="#7cb5eb"
                        strokeWidth={2}
                        dot
                    />
                    <Line
                        type="monotone"
                        dataKey="refiLoan"
                        name="Refinanced Loan"
                        stroke="#434348"
                        strokeWidth={2}
                        dot
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BreakEvenLineChart;
